import { IAdAdapter } from "./IAdAdapter";

export class MonetagAdapter implements IAdAdapter {
  readonly name = "monetag";

  constructor(private blockId: string) {}

  isAvailable(): boolean {
    return !!(window as any).Monetag;
  }

  async requestAd(_type: "rewarded" | "interstitial"): Promise<boolean> {
    throw new Error("not implemented");
  }

  async showAd(): Promise<boolean> {
    throw new Error("not implemented");
  }

  async showAdInterstitial(): Promise<void> {
    throw new Error("not implemented");
  }
}
